import ToolBase from '../basic';
import DEFINE from '../define';

export default class Polygon extends ToolBase {

    name = DEFINE.TOOLS.POLYGON;

    constructor(parent) {
        super(parent);
    }

    setting = null;
    polygon = null;
    isCreate = null;

    moveCount = 0;

    recover(object) {
        object.set({
            perPixelTargetFind: true,
            hasBorders: false,
            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            })
        })
    }

    mouseDown(o) {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.SHAPE);

        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        if (!this.isCreate) {
            this.isCreate = true;
            this.moveCount = 0;
            this.polygon = new fabric.Polygon([pointer, { x: pointer.x + 1, y: pointer.y + 1 }], {
                angle: 0,
                opacity: this.setting.opacity,
                fill: this.setting.fill,
                stroke: this.setting.stroke,
                strokeWidth: this.setting.strokeWidth
            });
            this.canvas.add(this.polygon);
        } else {
            this.moveCount++;

            let points = this.polygon.points;
            points.push(pointer);

            let newPolygon = new fabric.Polygon(points, {
                angle: 0,
                opacity: this.setting.opacity,
                fill: this.setting.fill,
                stroke: this.setting.stroke,
                strokeWidth: this.setting.strokeWidth
            });
            this.canvas.remove(this.polygon);
            this.canvas.add(newPolygon);
            this.polygon = newPolygon;
            this.canvas.renderAll();
        }

        if (o.target) {
            this.canvas.discardActiveObject(o.target);
        }

    }

    mouseMove(o) {
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        if (this.isCreate) {
            let points = this.polygon.points;

            if (points.length <= 1) return;
            if (points.length > this.moveCount) {
                this.polygon.points.pop();
            }

            this.polygon.points.push({
                x: pointer.x,
                y: pointer.y
            });
            this.canvas.remove(this.polygon);
            var obj = this.polygon.toObject(this.parent.proxy.extraAttribute);
            delete obj.top;
            delete obj.left;
            this.polygon = new fabric.Polygon(this.polygon.points, obj);
            this.canvas.add(this.polygon);
        }
    }

    mouseDBLClick(o) {
        if(this.isCreate) {
            this.polygon.points.pop();
            this.canvas.remove(this.polygon);
            var obj = this.polygon.toObject(this.parent.proxy.extraAttribute);
            delete obj.top;
            delete obj.left;
            this.polygon = new fabric.Polygon(this.polygon.points, obj);
            this.polygon.toolType = this.name;
            this.canvas.add(this.polygon);
    
            this.isCreate = false;
            this.canvas.renderAll();
    
            this.parent.addHistory();
        }
    }

    objectAdded(o) {
        let target = o.target;

        target.tag = DEFINE.TAG.POLYGON + new Date().getTime();
        target.cornerColor = DEFINE.COLOR.CORNER_COLOR;
        target.hasBorders = false;
        target.transparentCorners = false;
        target.selectable = true;
        target.perPixelTargetFind = true;
        target.paintFirst = "stroke";
        target.strokeUniform = true;
        target.controls = Object.assign(this.getBasicControls(), {
            mtr: this.getTouchRotateControl({
                x: 0.5,
                y: 0,
                offsetX: 25,
                offsetY: 0,
            }),
            deleteControl: this.getDeleteControl({
                x: 0.5,
                y: -0.5,
                offsetX: 25,
                offsetY: 0,
            }),
        })

        this.canvas.renderAll();
        this.parent.addHistory();
    }
}